const Dater = {
    getMondayDate (d){
        if(!(d instanceof Date))
            d = new Date(d);
        let day = d.getDay();
        let diff = d.getDate() - day + (day == 0 ? -6:1); // adjust when day is sunday
        return new Date(d.setDate(diff));
    },
    getFirstDateOfMonth (d){
        if(!(d instanceof Date))
            d = new Date(d);
        return new Date(d.getFullYear(), d.getMonth(), 1);
    },
    getDateOfNextMonth (d){
        if(!(d instanceof Date))
            d = new Date(d);
        return new Date(d.getFullYear(), d.getMonth() + 1, d.getDate());
    },
    getDateOfNextYear (d){
        if(!(d instanceof Date))
            d = new Date(d);
        return new Date(d.getFullYear() + 1, d.getMonth(), d.getDate());
    },
    getFirstDateOfYear (d){
        if(!(d instanceof Date))
            d = new Date(d);
        return new Date(d.getFullYear(),0,1);
    },
    getTotalNumbersOfDaysInYear(d){
        let year = d.getFullYear();
        let isLeap = this.isLeapYear(year);
        return (isLeap) ? 366 : 365;
    },
    isLeapYear(year){
        return year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0);
    },
    getDaysInMonth (d){
        let md = new Date(d.getFullYear(), d.getMonth() + 1, 0);
        return md.getDate();
    },
    getNextDayDate (d){
        return new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
    },
    getNumberOfDaysBetweenTwoDates(startDate, endDate){
        var oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds
        var sTime = startDate.getTime();
        var eTime = endDate.getTime();
        var days = Math.abs(sTime - eTime)/(oneDay);
        return Math.floor(days);
    },
    getNewDate(d, delta){
        return new Date(d.getFullYear(), d.getMonth(), d.getDate() + ((delta) ? delta : 0));
    },
    isInRange(startDate, endDate, checkDate){

        if(!startDate.getTime)
            startDate = new Date(parseInt(startDate));
        if(!endDate.getTime)
            endDate = new Date(parseInt(endDate));
        if(!checkDate.getTime)
            checkDate = new Date(parseInt(checkDate));
        let sdTime = startDate.getTime();
        let edTime = endDate.getTime();
        let cdTime = checkDate.getTime();
        let isInRange = (cdTime >= sdTime && cdTime <= edTime);
        return isInRange;
    },
    getPrevDate(date){
        if(!(date instanceof Date))
            date = new Date(date);
        return new Date(date.getFullYear(), date.getMonth(), date.getDate()-1);
    },

    getSMDate(date){
        if(!(date instanceof Date))
            date = new Date(date);
        let dateDay = date.getDate();
        if(dateDay > 15){ // get next Month Date
            return new Date(date.getFullYear(), date.getMonth() + 1, 1);
        }
        return new Date(date.getFullYear(), date.getMonth(), 15);
    },

    getNextSMDate(date){
        if(!(date instanceof Date))
            date = new Date(date);
        let dateDay = date.getDate();
        if(dateDay === 1){ // get next Month Date
            return new Date(date.getFullYear(), date.getMonth(), 15);
        }
        return new Date(date.getFullYear(), date.getMonth() + 1, 1);
    },

    getTodayTime(){
        let d = new Date();
        let todayDate = new Date(d.getFullYear(), d.getMonth(), d.getDate());
        return todayDate.getTime();
    },

    getNowTime(){
        let d = new Date();
        return d.getTime();
    },

    getStartOfDayTime(date){
        if(!(date instanceof Date))
            date = new Date(date);
        let d = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
        return d.getTime();
    },

/*  "d"  : "every day",
    "w"  : "every week",
    "bw" : "every other week",
    "sm" : "on 1st and 15th",
    "m"  : "monthly",
    "y"  : "yearly"*/
    getNextIntervalTime(date, interval){
        let d = new Date(date);
        switch(interval){
            case "d" : d = Dater.getNextDayDate(d); break;
            case "w" : d = Dater.getNewDate(d, 7); break;
            case "bw" : d = Dater.getNewDate(d, 14); break;
            case "sm" : d = Dater.getNextSMDate(d); break;
            case "m" : d = Dater.getDateOfNextMonth(d); break;
            case "y" : d = Dater.getDateOfNextYear(d); break;
        }
        d.setHours(0,0,0,0);
        return d.getTime();
    }
}

module.exports = Dater;


// WEBPACK FOOTER //
// ./src/control/util/Dater.js